const LOCAL_FRONTEND_API_BASE = 'http://localhost:8000';
const PROD_FRONTEND_API_BASE = 'https://askpoeai-nswdzfky7q-uc.a.run.app';

const normalizeHostname = (hostname?: string | null): string =>
  String(hostname || '')
    .trim()
    .toLowerCase();

export const isLocalFrontendHostname = (hostname?: string | null): boolean => {
  const normalizedHost = normalizeHostname(hostname);
  return normalizedHost === 'localhost' || normalizedHost === '127.0.0.1';
};

export const resolveFrontendApiBase = (
  configuredApiBase: string | null | undefined = process.env.REACT_APP_API_BASE,
  hostname: string | null | undefined = typeof window !== 'undefined'
    ? window.location.hostname
    : undefined,
): string => {
  const rawConfiguredBase = String(configuredApiBase || '').trim();
  const isLocalHost = isLocalFrontendHostname(hostname);

  if (!rawConfiguredBase) {
    return isLocalHost ? LOCAL_FRONTEND_API_BASE : PROD_FRONTEND_API_BASE;
  }

  if (/^https?:\/\//i.test(rawConfiguredBase)) {
    try {
      const configuredHostname = new URL(rawConfiguredBase).hostname.toLowerCase();
      if (!isLocalHost && isLocalFrontendHostname(configuredHostname)) {
        return PROD_FRONTEND_API_BASE;
      }
    } catch (_error) {
      // Use the configured value as-is if it is not a valid absolute URL.
    }
  }

  return rawConfiguredBase;
};

export { LOCAL_FRONTEND_API_BASE, PROD_FRONTEND_API_BASE };
